import type { VibeCheckAttachment } from '../api';

export function VibeCheckAttachments({ attachments, onRemove }: {
  attachments: VibeCheckAttachment[];
  onRemove?: (index: number) => void;
}) {
  return <ul className="vibe-check-attachments" aria-label={onRemove ? 'Attached files' : 'Message references'}>
    {attachments.map((attachment, index) => <li className="vibe-check-attachment" key={`${index}:${attachment.name}`}>
      {attachment.mediaType.startsWith('image/')
        ? <img src={`data:${attachment.mediaType};base64,${attachment.data}`} alt={`Preview of ${attachment.name}`} />
        : <span className="vibe-check-attachment-type" aria-hidden="true">{attachment.mediaType === 'application/pdf' ? 'PDF' : 'TXT'}</span>}
      <span className="vibe-check-attachment-name" title={attachment.name}>{attachment.name}</span>
      {onRemove && <button type="button" aria-label={`Remove ${attachment.name}`} onClick={() => onRemove(index)}>×</button>}
    </li>)}
  </ul>;
}
